import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Alert, Button, Group, Paper, Stack, Text, TextInput, Title } from '@mantine/core'
import { useShell } from '../AppShell'
import { createOrganisation } from '../org/api'

export default function NewOrg() {
  const { user } = useShell()
  const navigate = useNavigate()
  const [name, setName] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function submit(event: React.FormEvent) {
    event.preventDefault()
    if (busy || !name.trim()) return
    setBusy(true)
    setError(null)
    try {
      const orgId = await createOrganisation(name, user)
      navigate(`/o/${orgId}`, { replace: true })
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Could not create the organisation.')
      setBusy(false)
    }
  }

  return (
    <Paper withBorder p="lg" maw={620}>
      <Stack gap="md">
        <div>
          <Title order={1} size="h3">
            Create an organisation
          </Title>
          <Text c="dimmed" size="sm" mt={4}>
            An organisation is who a dashboard belongs to. Create one for a team so several people
            can share dashboards, invite each other, and hold different roles.
          </Text>
          <Text c="dimmed" size="xs" mt="xs">
            It's free and there's no limit worth worrying about — the thing that costs money is
            capturing timing data, and that is metered separately.
          </Text>
        </div>

        {error && <Alert color="red">{error}</Alert>}

        <form onSubmit={(e) => void submit(e)}>
          <Group align="flex-end">
            <TextInput
              style={{ flex: 1 }}
              label="Name"
              data-autofocus
              required
              placeholder="e.g. Quarendon Racing"
              value={name}
              onChange={(e) => setName(e.currentTarget.value)}
            />
            <Button type="submit" loading={busy} disabled={!name.trim()}>
              Create
            </Button>
            <Button component={Link} to="/" variant="subtle" color="gray">
              Cancel
            </Button>
          </Group>
        </form>
      </Stack>
    </Paper>
  )
}
